import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/data/data.js";
import "./swgfl/javascript/accessibility.js";
import "./swgfl/report/javascript/report.js";
import security from "./swgfl/security/javascript/all.js";
import cms from "./swgfl/cms/javascript/cms.js";
import forms from "./swgfl/forms/javascript/forms.js";
import hub from './swgfl/hub/javascript/all.js';
import faqs from "./swgfl/faqs/javascript/faqs.js";
import hashform from "./hashes/submit/javascript/all.js";
import survey from './hashes/survey/javascript/survey.js';
import api from "./hashes/api/javascript/api.js";
import apikeys from "./hashes/cms/javascript/apikeys.js";

// only the test build disables the hash form's automation check, vite fixes this at compile time
const test = import.meta.env.MODE === "test";

$(() => {
	security();
	hub();
	faqs($(".faqs"));
	cms($("#form-cms"));
	forms();
	hashform(test);
	survey($('#survey'));
	api($("#hash-api"));
	apikeys();
});
